// @ts-check
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';

export const useStatedataUpdate = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/account/user/stateData/index.raw').LWApiPublicAccountUserStateDataUpdateParamsRawI} params */
			(params) => api.account.user.stateData.apiRaw.update(params),

		onMutate: async (params) => {
			await queryClient.cancelQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: params.key }],
			});

			queryClient.setQueryData(
				['/account/user/statedata/listforkey', { key: params.key }],
				/** @param {import('club-sauce/public/account/user/stateData/index.raw').LWApiPublicAccountUserStateDataListForKeyResultRawI} current */
				(current) => {
					const data = JSON.parse(params.data);
					const updatedData = current.data.filter((d) => d.uuid !== data.uuid);

					return {
						...current,
						data: [data, ...updatedData],
					};
				},
			);
		},

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/account/user/statedata/listforkey'],
			});
		},

		onError: snackbarError,
	});
};

export const useUpdateFavorite = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn:
			/** @param {{uuid: string, path: string, displayName: string}} params */
			({ uuid, path, displayName }) =>
				api.account.user.stateData.apiRaw.update({
					key: 'favorites',
					data: JSON.stringify({ uuid, path, displayName }),
				}),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: 'favorites' }],
			});
		},
	});
};

export default useStatedataUpdate;
